import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// HOCS
import withLoading from 'hocs/WithLoading';
import withPermissions from 'hocs/WithPermissions';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import { publicName } from 'models/cpm/carpark';
// Custom
import { listRowSpecsShape, cpmCarparkDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'cpmCarparks/navigation';
import { addressDescCC } from 'utils/Tools';
import { SelectIconButton } from 'components/buttons/IconButtons';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';

const CarparkRow = React.forwardRef(({
  carpark, rowSpecs, handleStartLoading, hasPermission,
}, ref) => {
  const { id: carparkId } = carpark;
  // Specific permissions
  const { pCpm: { management } } = permissions;

  return (
    <TableRow
      ref={ref}
      element={carpark}
      rowSpecs={rowSpecs}
      actions={[
        <OnlyWith
          key="sPermission"
          permissions={{
            needed: management,
            permissionsOrContext: carpark.permissions,
          }}
        >
          <SelectIconButton
            key="bEdit"
            onClick={handleStartLoading}
            path={showPath(carparkId)}
          />
        </OnlyWith>,
      ]}
    >
      {/* ----- Name ----- */}
      <TableCell
        className={classnames({ 'table-first-details': rowSpecs.withDetails })}
      >
        <TruncatedTooltipText>
          {hasPermission({ needed: management, permissionsOrContext: carpark.permissions })
            ? carpark.name
            : publicName(carpark)}
        </TruncatedTooltipText>
      </TableCell>
      {/* ----- Address ----- */}
      <TableCell className="hidden-md-down">
        <TruncatedTooltipText>
          {addressDescCC(carpark.address)}
        </TruncatedTooltipText>
      </TableCell>
    </TableRow>
  );
});

CarparkRow.displayName = 'CarparkRow';

CarparkRow.propTypes = {
  carpark: cpmCarparkDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};

module.exports = compose(
  withLoading,
  withPermissions,
)(CarparkRow);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkRow.js